module.exports = __webpack_public_path__ + "static/media/Museum_main_t.cbc3b636.jpg";